import { HTTP } from "@/helpers/http-common"

const url = "/api/perfil"

const get = (data) => new Promise((resolve, reject) => {
  HTTP.get(`${url}/${data}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const list = (data) => new Promise((resolve, reject) => {
  HTTP.post(`${url}/list`, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const save = (data) => new Promise((resolve, reject) => {
  HTTP.post(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const update = (data) => new Promise((resolve, reject) => {
  HTTP.put(url, data
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const disable = (data) => new Promise((resolve, reject) => {
  const { clave } = data;
  HTTP.delete(url, { params: { clave } }).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error.response);
  });
});

const getPrivileges = (data) => new Promise((resolve, reject) => {
  HTTP.get(`/api/privilegiosPerfiles/${data}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const addPrivilege = (privilegio) => new Promise((resolve, reject) => {
  const { groupId, authority } = privilegio;
  HTTP.post("/api/privilegiosPerfiles", { groupId: { clave: groupId }, authority: (authority.key != undefined) ? authority.key : authority }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const removePrivilege = (privilegio) => new Promise((resolve, reject) => {
  const { groupId, authority } = privilegio;
  HTTP.delete("/api/privilegiosPerfiles", { params: { groupId, authority: (authority.key != undefined) ? authority.key : authority } }
  ).then((response) => {
    resolve(response)
  })
    .catch((error) => {
      reject(error)
    });
});

export default {
  get
  , list
  , save
  , update
  , disable
  , getPrivileges
  , addPrivilege
  , removePrivilege
}



// WEBPACK FOOTER //
// ./src/services/seguridad/perfil/index.js